import { Button } from 'antd';
import React from 'react';

const CommonButton = (props) => {
  const { ...rest } = props;
  return <Button {...rest} />;
};

export default CommonButton;
